import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'cfa-sante';
  // ALWAYS DISPLAY THE PAGE TO THE TOP
  onActivate(event) {
    window.scroll(0, 0);
  }
}
